export enum FilterButtonType {
  NotButton = 0,
  ClearButton = 1,
  FilterButton = 2,
}
